import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function listHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'listHeader',
    baseStyle: {
      paddingBottom: theme.space.s,
      borderBottom: `1px solid ${theme.colors.border15}`,
      fontSize: theme.sizes['2'],
      fontWeight: 500
    },
    variants: {
      title: {
        borderBottom: 'none',
        paddingTop: [theme.space['xs'], theme.space.s],
        paddingBottom: [theme.space['2xs'], theme.space['3xs']],
        paddingLeft: [theme.space['3xs'], theme.space['3xs']],
        fontSize: [theme.sizes['3'], theme.sizes['2']]
      }
    }
  };
}
